export default function UploadedFilePreview({ fileType, url }) {
  if (!url) return null; // No URL to preview

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  return (
    <div className="current-upload-indicator mb-3 p-3 border rounded bg-light">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <span className="text-success fw-bold">
            ✓ {capitalizeFirstLetter(fileType)} uploaded successfully
          </span>
          <br />
          <small className="text-muted">
            Click below to replace with a new {fileType}
          </small>
        </div>
        <img
          src={url}
          hidden={fileType !== "image"}
          alt="Current upload"
          style={{
            width: "60px",
            height: "60px",
            objectFit: "cover",
            borderRadius: "4px",
          }}
        />

        <video
          hidden={fileType !== "video"}
          src={url}
          style={{
            width: "80px",
            height: "60px",
            objectFit: "cover",
            borderRadius: "4px",
          }}
          muted
        />
      </div>
    </div>
  );
}
